import { getApiConfig } from "./context";

export const nativeFetch = window.fetch;

export function dbfetch(input, options) {
	/* tokens are only passed if exists and url is same-origin and under the same db path, to prevent leaking tokens to third-party */
	const fetchToken = getApiConfig("fetchToken");
	if (fetchToken) {
		let url = input instanceof Request ? input.url : input;
		const locationPathPrefix = location.href.replace(/^(.*\/db\/[-\d]+\/).*/i, "$1");
		const reqUrl = new URL(url, locationPathPrefix);
		const urlPathPrefix = reqUrl.href.replace(/^(.*\/db\/[-\d]+\/).*/i, "$1");
		if (locationPathPrefix.toLowerCase() === urlPathPrefix.toLowerCase()) {
			// same DB call, extend headers with token
			const fetchTokenHeaderName = "X-Fetch-Token";
			if (options == null) {
				// no options? create new
				options = { headers: { [fetchTokenHeaderName]: fetchToken } };
			} else if (options.headers instanceof Headers) {
				// options.headers is a Headers object. If there is no token, clone headers and options
				if (!options.headers.has(fetchTokenHeaderName)) {
					const headers = new Headers(options.headers);
					headers.set(fetchTokenHeaderName, fetchToken);
					options = { ...options, headers };
				}
			} else if (options.headers == null) {
				// null or undefined ? create plain object header
				options = { ...options, headers: { [fetchTokenHeaderName]: fetchToken } };
			} else if (typeof options.headers === "object") {
				// not-null plain object header? replace options with extended header with token
				if (!options.headers[fetchTokenHeaderName])
					options = { ...options, headers: { ...options.headers, [fetchTokenHeaderName]: fetchToken } };
			}
		}
	}
	return nativeFetch(input, options);
}